// Statsig client reference — set by App component via useClientAsyncInit
// We use a loose type to avoid importing from non-hoisted transitive deps

interface StatsigClientRef {
  logEvent(name: string, value?: string | number, metadata?: Record<string, string>): void
}

let client: StatsigClientRef | null = null

export function getStatsigClient(): StatsigClientRef | null {
  return client
}

export function setStatsigClient(c: StatsigClientRef) {
  client = c
}

export function getStatsigClientKey(): string {
  return import.meta.env.VITE_STATSIG_CLIENT_KEY ?? ""
}

export function getStatsigEnvironment(): string {
  return import.meta.env.VITE_STATSIG_ENVIRONMENT || "development"
}
